// extracted by mini-css-extract-plugin
module.exports = {"background-image":"DonationCampaignBannerSection_background-image__UMPJd","banner-container":"DonationCampaignBannerSection_banner-container__3zpC1"};